import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});

export default (env, state = INITIAL_STATE, action) => {
    switch (action.type) {
        case `${env.toUpperCase()}__SET_USERS`:
            return core.setUsers(state, action.users);
        case `${env.toUpperCase()}__UPDATE_HOME_USERS`:
            return core.updateHomeUsers(state, action.homeUsers);
        case `${env.toUpperCase()}__DELETE_USER`:
            return core.deleteUser(state, action.userId);
        case `${env.toUpperCase()}__DELETE_AND_UPDATE_HOME_USER`:
            return core.deleteAndUpdateUser(state, action.userId, action.homeUsers);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Users/reducer.js